{
  "language": {
    "name": "한국어",
    "title": "언어"
  },
  "format": {
    "currency": "{{value, currency(currency: USD)}}",
    "number": "{{value, number(maximumFractionDigits: 9)}}"
  },
  "button": {
    "auto": "자동",
    "bridge": "브릿지",
    "buy": "매수",
    "buyNow": "즉시 매수",
    "cancel": "취소",
    "connectWallet": "지갑 연결",
    "contactSupport": "고객 지원",
    "continue": "계속",
    "copyAddress": "주소 복사",
    "dark": "어둡게",
    "delete": "삭제",
    "disconnect": "연결 해제",
    "done": "완료",
    "exchange": "교환",
    "getGas": "가스 받기",
    "hide": "숨기기",
    "learnMore": "자세히 알아보기",
    "lifiCheckout": "LI.FI 결제",
    "lifiExchange": "LI.FI 교환",
    "light": "밝게",
    "max": "최대",
    "ok": "확인",
    "removeTransaction": "거래 지우기",
    "reset": "초기화",
    "resetSettings": "설정 초기화",
    "reviewBridge": "브릿지 리뷰",
    "reviewPurchase": "매수 검토",
    "reviewSwap": "스왑 검토",
    "seeDetails": "자세히 보기",
    "showAll": "모두 보기",
    "startBridging": "브릿지 시작하기",
    "startSwapping": "스왑 시작하기",
    "swap": "스왑",
    "tryAgain": "다시 시도",
    "viewCoverage": "보장 범위",
    "viewOnExplorer": "탐색기에서 보기"
  },
  "header": {
    "activeTransactions": "활성화된 거래",
    "bridge": "브릿지",
    "checkout": "주문",
    "exchange": "교환",
    "from": "다음에서 스왑",
    "gas": "가스",
    "payWith": "결제 수단",
    "purchase": "구입",
    "purchaseDetails": "주문 세부사항",
    "selectChain": "체인 선택",
    "selectWallet": "지갑 선택",
    "settings": "설정",
    "swap": "스왑",
    "to": "다음으로 스왑",
    "transactionDetails": "거래 세부사항",
    "transactionHistory": "거래 내역",
    "walletConnected": "지갑 연결됨",
    "youGet": "받는 수량"
  },
  "info": {
    "message": {
      "autoRefuel": "현재 {{chainName}} 가스가 부족합니다. 이 기능을 통하여 스왑을 완료할 가스를 보충할 수 있습니다.",
      "emptyActiveTransactions": "진행 중인 스왑이 여기에 나타납니다. 완료 후에는 스왑 기록을 참조하십시오",
      "emptyTokenList": "{{chainName}} 체인에서 토큰을 찾을 수 없거나 보유 중인 토큰이 아닙니다. 다시 검색하거나 다른 체인을 선택하십시오.",
      "emptyTransactionHistory": "스왑 기록은 로컬에만 저장되며 브라우저 데이터를 지우면 삭제됩니다.",
      "routeNotFound": "이유: 낮은 유동성, 선택된 수량이 너무 적음, 가스비가 너무 비싸거나 경로가 존재하지 않음"
    },
    "title": {
      "autoRefuel": "가스 받기",
      "emptyActiveTransactions": "활성화된 거래가 없음",
      "emptyTransactionHistory": "최근 거래 없음",
      "routeNotFound": "가능한 경로가 없음"
    }
  },
  "success": {
    "message": {
      "exchangePartiallySuccessful": "스왑을 시도했지만, {{tokenSymbol}} 토큰에 대한 {{tool}}의 유동성이 부족합니다.",
      "exchangeSuccessful": "{{walletAddress}} 지갑의 {{chainName}} 체인에 {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}이(가) 있습니다.",
      "purchaseSuccessful": "{{walletAddress}} 지갑의 {{chainName}} 체인에 {{assetName}} 을 획득하셨습니다."
    },
    "title": {
      "bridgePartiallySuccessful": "부분 스왑 성공",
      "bridgeSuccessful": "브릿지 성공",
      "purchaseSuccessful": "구입 성공",
      "refundIssued": "환불되었습니다",
      "swapPartiallySuccessful": "부분 스왑 성공",
      "swapSuccessful": "스왑 성공"
    }
  },
  "warning": {
    "message": {
      "deleteActiveTransactions": "활성화된 스왑은 로컬에만 저장되며 삭제시 복구할 수 없습니다.",
      "deleteTransactionHistory": "스왑 기록은 로컬에만 저장되며 삭제시 복구할 수 없습니다.",
      "highValueLoss": "받은 토큰의 가치가 스왑된 토큰 및 트랜잭션 비용보다 상당히 낮습니다.",
      "insufficientFunds": "스왑을 진행할 자금이 부족합니다.",
      "insufficientGas": "스왑을 진행할 가스가 부족합니다. 최소 다음과 같은 가스가 필요합니다:",
      "rateChanged": "거래 비율이 변경되었습니다. 스왑을 계속하면 새로운 비율이 적용됩니다.",
      "resetSettings": "우선 경로, 슬리피지, 가스 비용, 활성화된 브릿지 및 거래소가 재설정됩니다."
    },
    "title": {
      "deleteActiveTransactions": "모든 활성화된 거래를 삭제합니까?",
      "deleteTransaction": "이 거래를 삭제합니까?",
      "deleteTransactionHistory": "거래 내역을 삭제합니까?",
      "highValueLoss": "높은 가치 손실",
      "insufficientGas": "가스 부족",
      "rateChanged": "비율 변경됨",
      "resetSettings": "설정을 초기화합니까?"
    }
  },
  "error": {
    "message": {
      "allowanceRequired": "{{tokenSymbol}} 이체 금액이 한도를 초과했습니다. 한도를 증액한 뒤 다시 시도해주십시오.",
      "insufficientFunds": "트랜잭션에 필요한 가스비가 부족합니다.",
      "slippageThreshold": "슬리피지가 한계점보다 큽니다. 새로운 견적을 얻기 위해 새 경로를 요청하십시오.",
      "transactionFailed": "자세한 정보는 블록 탐색기에서 확인하세요.",
      "transactionNotSent": "트랜잭션 전송에 실패했습니다. {{chainName}}의 {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}이 지갑에 남아있습니다.",
      "transactionRejected": "트랜잭션 완료를 위해 서명이 필요합니다. {{chainName}}의 {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}이 지갑에 남아있습니다.",
      "unknown": "다시 시도하거나 고객 센터에 문의하십시오."
    },
    "title": {
      "allowanceRequired": "한도 부족",
      "balanceIsTooLow": "잔액이 부족합니다.",
      "chainSwitch": "체인을 변경하십시오",
      "gasLimitIsTooLow": "가스 한도가 너무 낮습니다",
      "insufficientFunds": "잔고 부족",
      "slippageNotMet": "슬리피지 조건을 충족하지 못했습니다.",
      "transactionCanceled": "거래가 취소되었습니다",
      "transactionFailed": "거래가 실패하였습니다",
      "transactionRejected": "서명이 필요합니다",
      "transactionUnderpriced": "거래 가격이 너무 낮습니다",
      "transactionUnprepared": "트랜잭션을 진행할 수 없습니다.",
      "unknown": "문제가 발생했습니다",
      "walletAddressInvalid": "지갑 주소가 유효하지 않습니다.",
      "walletAddressRequired": "지갑 주소가 필요합니다.",
      "walletEnsAddressInvalid": "지갑 주소가 유효하지 않거나 네트워크가 ENS를 지원하지 않습니다."
    }
  },
  "tooltip": {
    "additionalProviderFee": "추가적인 브릿지, 덱스, 그리고 서비스 수수료",
    "estimatedNetworkFee": "예상 네트워크 수수료",
    "estimatedTime": "예상 스왑 시간(분)",
    "notFound": {
      "text": "페이지를 찾을 수 없습니다.",
      "title": "404"
    },
    "numberOfSteps": "여러 스왑 단계. 각 단계 진행을 위해서는 1-2개의 트랜잭션 서명이 필요할 수 있습니다.",
    "progressToNextUpdate": "표시된 데이터가 {{value}} 초 후에 자동 새로고침 됩니다. 수동으로 업데이트 하려면 여기를 클릭하십시오.",
    "recommended": "편리성과 복잡성에 균형을 둔 저렴한 루트",
    "settingsModified": "설정 (수정됨)"
  },
  "main": {
    "crossStepDetails": "{{tool}}을 통해 {{from}}(으)로부터 {{to}}(으)로 브릿지",
    "currentAmount": "현재 수량",
    "estimatedTime": "{{value}}분",
    "featuredTokens": "주요 토큰",
    "from": "[Value] 를",
    "fromAmount": "지불 수량",
    "gasCost": "가스비",
    "gasFeeEstimated": "예상 가스비",
    "gasFeePaid": "가스비 지불됨",
    "inProgress": "진행 중",
    "nftStepDetails": "{{tool}} 를 통해 NFT 구입",
    "onChain": "{{chainName}} 에서",
    "otherTokens": "다른 토큰",
    "ownedBy": "소유자: ",
    "process": {
      "crossChain": {
        "actionRequired": "트랜잭션을 서명하십시오.",
        "done": "브릿지 트랜잭션이 확인됨",
        "pending": "브릿지 트랜잭션 대기 중",
        "started": "브릿지 트랜잭션 준비 중"
      },
      "nft": {
        "done": "NFT 구입 성공"
      },
      "receivingChain": {
        "done": "브릿지 완료",
        "partial": "브릿지 부분 완료",
        "pending": "도착 체인 대기 중",
        "refunded": "브릿지 트랜잭션 환불됨"
      },
      "swap": {
        "actionRequired": "트랜잭션을 서명하십시오",
        "done": "스왑 완료",
        "pending": "스왑 트랜잭션 대기 중",
        "started": "스왑 트랜잭션 준비 중"
      },
      "switchChain": {
        "actionRequired": "체인 전환 요청됨",
        "done": "체인 전환 완료"
      },
      "tokenAllowance": {
        "done": "토큰 허용 승인됨",
        "pending": "토큰 허용 대기 중",
        "started": "토큰 허용 설정"
      }
    },
    "quotedAmount": "견적",
    "rateChange": "비율 변경",
    "receiving": "받는 중",
    "refuelStepDetails": "{{tool}} 를 통해 가스 얻기",
    "selectChain": "체인 선택",
    "selectChainAndToken": "체인과 토큰 선택",
    "selectToken": "토큰 선택",
    "sendToAddress": "{{address}}로 전송",
    "sendToWallet": "다른 지갑으로 전송",
    "sending": "전송중",
    "sentToAddress": "{{address}}로 전송",
    "stepBridge": "브릿지",
    "stepBridgeAndBuy": "브릿지 그리고 매수",
    "stepDetails": "LI.FI 를 통한 {{tool}}",
    "stepSwap": "스왑",
    "stepSwapAndBridge": "스왑 그리고 브릿지",
    "stepSwapAndBuy": "스왑 그리고 매수",
    "supportId": "서포트 ID",
    "swapStepDetails": "{{tool}}로 {{chain}}에서 스왑",
    "tags": {
      "cheapest": "저렴한",
      "fastest": "빠르게",
      "insurable": "보험 적용 가능한",
      "insurance": "보험",
      "insured": "보험 적용됨",
      "recommended": "추천",
      "safest": "안전한"
    },
    "to": "도착",
    "tokenOnChain": "{{chainName}}의 {{tokenSymbol}}",
    "tokenOnChainAmount": "{{chainName}}의 {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}",
    "tokenSearch": "이름 또는 컨트랙트 주소를 통해 검색",
    "valueLoss": "가치 손실",
    "walletAddressOrEns": "지갑 주소 또는 ENS"
  },
  "insurance": {
    "bridgeExploits": "브릿지 오류, 해킹, 취약점 공격",
    "insure": "브릿지 중인 <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> 보험 적용",
    "insured": "브릿지 중인 <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> 보험 적용 완료",
    "slippageError": "받을 토큰의 슬리피지 오류가 발생했습니다."
  },
  "settings": {
    "enabledBridges": "활성화된 브릿지",
    "enabledExchanges": "지원 거래소",
    "gasPrice": {
      "fast": "빠르게",
      "normal": "표준",
      "slow": "느리게",
      "title": "가스 가격"
    },
    "routePriority": "우선 경로",
    "showDestinationWallet": "받는 지갑 보기",
    "slippage": "슬리피지"
  },
  "wallet": {
    "extensionNotFound": "이 지갑을 선택하기 전 {{name}} 브라우저만 활성화 상태인지 확인하십시오."
  }
}
